export { HeaderSimple, type HeaderSimpleProps } from "./HeaderSimple";
